<template>
  <layout-page :nav-bar-show-logo-text="false">
    <page-breadcrumb :hierarchy="breadCrumbs"/>
    <div class="container">
      <h1 class="font-large text-blue-60 text-2xl text-center py-4 lg:text-left lg:text-3xl">
        <span class="font-extrabold">How to use Agency Central</span>
      </h1>
      <p class="list-decimal text-lg text-grey-70">
        Agency Central is the fast and easy way to find a recruitment agency. Whether you’re looking for staff, or a
        job, you can use our website to search for recruitment agencies in your industry and location.
      </p>
      <h2 class="font-large text-blue-60 text-2xl py-4 lg:text-left lg:text-3xl">
        <span class="font-extrabold">Three steps to using Agency Central</span>
      </h2>
      <ol class="font-bold list-decimal text-xl text-blue-60">
        <li>
          <div id="complete-search-box">
            <span class="font-bold">Complete the search box</span>
            <div class="flex justify-center items-center py-3">
              <img
                  :src="asset_path('/images/htu_searchbox_screenshot.png')"
                  alt="SearchBox Screenshot"
                  class="lg:w-[80%]"
              />
            </div>
            <div class="font-normal text-lg text-grey-70">
              <p class="pt-2 pb-2">
                Use the search box to find recruitment agencies that are relevant to your industry, job role and
                location.
                Don’t forget to tell us whether you’re an employer or job seeker!
              </p>
            </div>
          </div>
        </li>

        <li>
          <div id="read-search-results">
            <span class="font-bold">Read your search results</span>
            <div class="flex justify-center items-center py-3">
              <img
                  :src="asset_path('/images/htu_agency_listing_screenshot.png')"
                  alt="SearchBox Screenshot"
                  class="lg:w-[80%]"
              />
            </div>
            <div class="font-normal text-lg text-grey-70">
              <p class="pt-2 pb-2">
                Browse the results page and find out more about each agency. We’ve tried to provide as much information
                as
                possible to help you make an informed decision.
              </p>
            </div>
          </div>
        </li>

        <li>
          <div id="contact-agency">
            <span class="font-bold">Contact a recruitment agency</span>
            <div class="flex justify-center items-center py-3">
              <img
                  :src="asset_path('/images/htu_contact_options_screenshot.png')"
                  alt="SearchBox Screenshot"
              />
            </div>
            <div class="font-normal text-lg text-grey-70">
              <p class="pt-2 pb-2">
                Once you’ve chosen an agency (we recommend three), simply send an email, take their number or visit
                their website.
              </p>
              <p class="pb-2">
                You may be asked to leave your name or some other details; don’t worry, this is just to let the agency
                know that you found them through Agency Central.
              </p>
              <p class="pb-2">
                Still need help contacting a recruitment agency? Click the online chat below or call our assisted search
                line on 0330 380 0650. Please note that this line is for employers only.
              </p>
            </div>
          </div>
        </li>
      </ol>
    </div>
  </layout-page>
</template>

<script>
import LayoutPage from 'Components/layouts/LayoutPage';
import NavBar from 'Components/NavBar/NavBar';
import PageBreadcrumb from 'Components/PageBreadcrumb';

export default {
  name: 'HowToUse',
  components: {
    PageBreadcrumb,
    LayoutPage,
    NavBar,
  },
  computed: {
    breadCrumbs: function () {
      return [
        {
          name: 'How to use Agency central'
        }
      ]
    }
  }
};
</script>
